/**
 * Insert letterImage as a direct child of doc, adjacent to the top-level
 * block under the current selection.
 *
 * @param {{ $from: { depth: number, after: (depth: number) => number }, to?: number }} selection
 * @returns {number | null} document position, or null when unresolved
 */
export function resolveLetterImageDocInsertPos(selection) {
  if (!selection || typeof selection !== 'object') return null;
  const $from = selection.$from;
  if (!$from || typeof $from.depth !== 'number') return null;

  if ($from.depth >= 1) {
    if (typeof $from.after !== 'function') return null;
    try {
      const pos = $from.after(1);
      return typeof pos === 'number' && pos >= 0 ? pos : null;
    } catch {
      return null;
    }
  }

  if (typeof selection.to === 'number' && selection.to >= 0) {
    return selection.to;
  }
  return null;
}

/**
 * Pure JSON helper for tests: insert image after a top-level doc child index.
 * @param {object} document
 * @param {number} afterTopLevelIndex
 * @param {object} attrs
 */
export function insertLetterImageAfterTopLevelIndex(document, afterTopLevelIndex, attrs) {
  const content = Array.isArray(document?.content) ? [...document.content] : [];
  const image = {
    type: 'letterImage',
    attrs: {
      assetId: attrs.assetId,
      widthPct: attrs.widthPct ?? 50,
      align: attrs.align ?? 'center',
      alt: attrs.alt ?? '',
    },
  };
  const index = Math.max(-1, Math.min(afterTopLevelIndex, content.length - 1));
  content.splice(index + 1, 0, image);
  return { type: 'doc', content };
}
